module.exports = __webpack_public_path__ + "img/9788964371831.b8bd93ff.jpg";